module.exports = __webpack_public_path__ + "img/visuel_erreur_404.718aaafb.svg";